// packages/types/src/uc/uc-export.ts
// Mapovania NAŠA doména → UC číselník. Sem patria len prevody, kde sa naša
// hodnotová sada s UC nezhoduje 1:1 (zvyšok enumov je bijektívny a stačí
// `ucIdOf` nad tabuľkami v `attributes.ts`).
//
// Vlastný súbor preto, aby `attributes.ts` (čistý číselník) nemusel poznať
// doménové typy — oba importy sú tu `import type`, takže modul nemá žiadnu
// runtime závislosť.

import type { PropertyEnergyClass } from '../domain/property.types'
import type { UcEnergyCert } from './attributes'

/**
 * Náš `PropertyEnergyClass` → UC certifikát. Trieda A je u nás rozdelená na
 * A0–A3 (legislatíva SK), UC pozná len jedno „A".
 *
 * Bez `Record<string, …>` anotácie zámerne: kľúče ostávajú presné, takže preklep
 * pri čítaní zachytí `tsc`. Na runtime string (hodnota z DB) je určený totálny
 * `energyClassToUcCert`.
 */
export const ENERGY_CLASS_TO_UC_CERT = {
  A0: 'A', A1: 'A', A2: 'A', A3: 'A', B: 'B', C: 'C', D: 'D', E: 'E', F: 'F', G: 'G',
} satisfies Record<PropertyEnergyClass, UcEnergyCert>

/**
 * Bezpečný lookup pre runtime stringy (rovnaký vzor ako `ucIdOf`) — neznáma
 * trieda vráti `undefined`, nie crash a nie nesprávny certifikát.
 */
export function energyClassToUcCert(energyClass: string | null | undefined): UcEnergyCert | undefined {
  if (!energyClass) return undefined
  return (ENERGY_CLASS_TO_UC_CERT as Record<string, UcEnergyCert | undefined>)[energyClass]
}
